import PropTypes from 'prop-types'
import React from 'react'
import SVG from '../../../assets/logo/neoskop-signet.svg'
import './styles.scss'

const Signet = ({ size }) => (
  <div className="signet" style={{ '--size': size + 'px' }}>
    <SVG />
  </div>
)

Signet.propTypes = {
  size: PropTypes.number
}

Signet.defaultProps = {
  size: 72
}

export default Signet
